import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Page from '../Page.js';
import PageContentWrapper from "../../components/PageContentWrapper.js";
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants.js';
import FormPartialNew from './FormPartialNew.js';
import OfferAddon from '../../models/OfferAddon';
import { getApi } from '../../api/endpoints.js';
import { toast } from 'react-toastify';

const New = (props) => {

  const navigate = useNavigate();
  let offerAddonObj = new OfferAddon();
  const [offerAddon, setOfferAddon] = useState(offerAddonObj.toStateJson());
  const [createApi] = getApi('createManyOfferAddons')


  const createRecord = async (params) => {
    try {
      await createApi(params).unwrap();
      navigate("/offer_addons");
      toast.success("Created Successfully.");
    } catch(error) {
      let offerAddonObj = new OfferAddon(offerAddon);
      offerAddonObj.set_api_errors(error.data.data.errors);
    }
  }

  const handleSubmitFunction = () => {
    try{
      createRecord((new OfferAddon(offerAddon)).toApiJson())  
    } catch(error){
      setOfferAddon(new OfferAddon(offerAddon));
    }
  }

  const handleCancelFunction = () => {
    navigate('/offer_addons');
  }

  return <Page
      uiPage={uiManager.getUiPage(PAGES.NewOfferAddonPage.name)}
      breadcrumbs={[{ label: "Home", url: '/dashboard' }, { label: "Offer Addons List", url: '/offer_addons' }, { label: "Generate New Offer Addon" }]}
      className={'offer-addon-page'}
    >
      <PageContentWrapper contentHeading={"Generate New Offer Addon"}>
        <div className='m-3'>
          <div className='mb-4 col-md-12'>
            <form className="row g-3" autoComplete="off">
              <FormPartialNew offerAddon={offerAddon} setOfferAddon={setOfferAddon} />
              <div className='mb-4 col-md-12'>
                <div >
                  <button style={{ float: 'inline-start' }} type="button" className="btn btn-voltup-theme" onClick={handleCancelFunction}>Back</button>
                  <button type="button" className="btn btn-voltup-theme ms-3" onClick={handleSubmitFunction}>Create Offer Addon</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </PageContentWrapper>
    </Page>
}

export default New;
